module.exports = __webpack_public_path__ + "static/media/40_A.9162ffaf.png";